import { DataStringComponent } from "./data-string-component.js";

export class DataBooleanComponent extends DataStringComponent {
    static webComponentName: string = "data-boolean";
    protected _templateId: string = "data-boolean-component";
    protected inputType: string = "checkbox";
    constructor() {
        super();
        this.addEventListener('component-rendered', (ev: Event) => {
            const evt = ev as CustomEvent;
          
        });
    }
    addDataForTemplate(): Record<string, any> {
        const data = super.addDataForTemplate();
        if(this.value === undefined || this.value === null) {
            this.value = this.field.defaultValue || false;
        }
        return {
            ...data,
            value: this.value ,
        };
    }
}